module.exports = __webpack_public_path__ + "static/media/Group 3.c4501c55.svg";